import { useEffect, useState } from "react";
import TextInput from "../TextInput";
import "../../container/styles.css";
import ReactPlayer from "react-player";
import ApiService from "../../api/ApiServices";
import ChallengeSuccessModalProps from "../ChallengeSuccessModal";
import AlertModal from "../AlertModal";
const HomeScrollVidFragment = ({
  onClick,
  imgStyle = null,
  contStyle = null,
  id,
  picUrl,
  handleSuccess,
  hideText,
  handleReadMore,
  data,
  isHallow,
  thumbnail,
  onCompleted,
  skipAvailabilityCheck = false,
  isChallengeCompleted,
}: {
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  imgStyle?: any;
  contStyle?: any;
  id?: any,
  picUrl?: any,
  handleSuccess?: any,
  hideText?: any,
  handleReadMore?: any;
  data?: any;
  isHallow?: any;
  thumbnail?:any;
  onCompleted?: any;
  skipAvailabilityCheck?: boolean;
  isChallengeCompleted?: boolean;
}) => {
  const [localChallengeCompleted, setLocalChallengeCompleted] = useState<boolean>(false);
  const resolvedIsChallengeCompleted = Boolean(isChallengeCompleted || localChallengeCompleted);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("Challenge completed");
  const [successResponse, setSuccessResponse] = useState<any>(null);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");

  const openAlert = (message: string) => {
    setAlertMessage(message);
    setShowAlert(true);
  };

  const checkChallengeCompleted = async (challengeId: string) => {
    try {
      const availableResponse = await ApiService.getAvailableChallenges();
      const availableChallenges = availableResponse?.data || [];
      const isAvailable = availableChallenges?.some((item: any) => {
        const availableId = item?._id || item?.challengeId?._id || item?.challengeId;
        return availableId === challengeId;
      });
      setLocalChallengeCompleted(!isAvailable);
    } catch (error) {
      setLocalChallengeCompleted(false);
    }
  };

  useEffect(() => {
    if (typeof isChallengeCompleted === "boolean") {
      return;
    }

    if (skipAvailabilityCheck) {
      setLocalChallengeCompleted(false);
      return;
    }

    if (id) {
      checkChallengeCompleted(id);
    }
  }, [id, skipAvailabilityCheck, isChallengeCompleted]);
  console.log('picUrl',picUrl);
  const [inputValue, setInputValue] = useState("");
  const handleInputChange = (e: any) => {
    setInputValue(e.target.value);
  };

  const handleSubmit = async () => {
    if (!inputValue || resolvedIsChallengeCompleted) {
      if (!inputValue) {
        openAlert("please add some text");
      }
      return
    }
    try {
      const response = await ApiService.answerText({
        challengeId: id,
        answer: inputValue,
      });
      if (response?.status) {
        setSuccessMessage(response?.message || "Challenge completed");
        setSuccessResponse(response);
        setShowSuccessModal(true);
        setInputValue('')
        setLocalChallengeCompleted(true);
      }
    } catch (error) {
      console.error("Error while submitting answer:", error);
    }
  }
  const getYouTubeVideoId = (url: string) => {
    const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url?.match(regExp);
    return (match && match[2].length === 11) ? match[2] : null;
  };
  return (
    <>
      <AlertModal
        visible={showAlert}
        title="Oops!"
        message={alertMessage}
        onConfirm={() => setShowAlert(false)}
      />
      <ChallengeSuccessModalProps
        visible={showSuccessModal}
        message={successMessage}
        onConfirm={() => {
          setShowSuccessModal(false);
          onCompleted && onCompleted();
          handleSuccess && handleSuccess(successResponse);
        }}
      />
      <div
        onClick={onClick}
        className={`flex flex-col flex-1 home-frag-cont mr-3 ${contStyle && contStyle
          } relative`}
      >
      {/* <img
        alt=""
        className={`home-frag-img ${imgStyle}`}
        src={require("../../assets/homeFragVid.png")}
      /> */}
      {data?.additionalInfo !== "" && !isHallow && <button
        className="absolute top-3 right-4 text-sm font-bold h-8 w-8 text-black readmore-btn"
        onClick={() => handleReadMore(data?.additionalInfo)}
      >
        ?
      </button>}
      <div className={`home-frag-img overflow-hidden  ${imgStyle}`}>
        {isHallow ? <img src={thumbnail}  alt={thumbnail}  /> : <ReactPlayer
          width="100%"
          height="100%"
          style={{
            borderTopLeftRadius: 12,
            borderTopRightRadius: 12,
            overflow: "hidden",
          }}
          playing
          url={picUrl}
          light={thumbnail}
        />}
      </div>

        {!hideText && !resolvedIsChallengeCompleted && <div className="flex flex-row items-center">
          <TextInput
            placeholder="Enter your answer..."
            value={inputValue}
            containerStyles="ml-2 pl-2 py-1 my-2 "
            onChange={handleInputChange}
            textInputStyles={{ maxWidth: "96%",paddingLeft: 4, paddingRight: 4 }}
          />
          <div className={`primary-btn challenge-sml-btn flex px-1 py-1 mx-2`} onClick={handleSubmit}>
            <div className={`inter-12-bold text-white px-1`}>SUBMIT</div>
          </div>
        </div>}
      </div>
    </>
  );
};

export default HomeScrollVidFragment;
